module.exports = __webpack_public_path__ + "img/inter1.cff550bb.jpg";